<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header__icon-wrapper">
                <mdi-icon icon="mdiNewspaperVariantMultipleOutline" class="card-header__icon" />
            </div>

            <div class="card-header__title">
                {{ t('home.widgets.news.title') }}
            </div>
        </div>

        <div v-if="hasNews" class="w-full text-center">
            <!-- <opti-munich-promotion
                v-if="hasOptiTicket"
                format="stacked"
                class="m-4"
            /> -->

            <!-- <div v-if="cEntity.country == 'FR'" class="">
                <img src="/img/opto-meetings-2025.jpg" />
            </div> -->

            <div class="">
                <!-- <img
                    v-if="cEntity.country === 'FR'"
                    src="/img/christmas-deliveries-fr.jpg" alt=""
                >
                <img
                    v-else-if="cEntity.country === 'DE'"
                    src="/img/christmas-deliveries-de.jpg" alt=""
                >
                <img
                    v-else
                    src="/img/christmas-deliveries-en.jpg" alt=""
                > -->
                <!-- <a v-if="cEntity.country === 'UA'" href="https://pan.ac/swiss" target="_blank">
                    <img src="/img/ua_conference_2026.png" alt="UA Conference 2026" />
                </a> -->
            </div>

            <sl-academy-news class="m-2" />

            <div
                v-for="(n, index) in news"
                :key="index"
                class="border-b border-gray-200 py-3 px-4 text-left text-gray-600 text-sm"
                v-html="n"
            >
            </div>
        </div>

        <div v-else class="no-news">
            {{ t('home.widgets.news.none') }}
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import constants from '@/constants/constants';
import OptiMunichPromotion from '@/components/promotions/OptiMunichPromotion.vue';
import SlAcademyNews from '@/components/promotions/SlAcademyNews.vue';
import useOptiMunichPromotionComposable from '@/composables/OptiMunichPromotionComposable';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n({ useScope: 'global' });
const { hasOptiTicket } = useOptiMunichPromotionComposable();

const news = ref([]);

const cEntity = computed(() => store.state.account.cEntity);
const hasNews = computed(() => hasOptiTicket.value || news.value.length);

onMounted(() =>
{
    // Add German phone number
    if(['AT', 'DE'].includes(cEntity.value.country))
    {
        news.value.push(t('home.widgets.news.new_german_phone_number'));
    }
});
</script>

<style scoped>
@reference "#main.css";

.card
{
    @apply min-h-[300px];
}

.no-news
{
    @apply mt-8 w-full text-center text-gray-500;
}
</style>
